<template>
  <div class="role-list-content">
    <div>
      <el-row class="role-list-header">
        <el-col :span="12" class="role-list-header-title">
          角色
        </el-col>
        <el-col :span="12" style="text-align: right">
          <a style="cursor: pointer;" v-if="$permission('role:add')" @click="openEditRole(null)">
            <!-- <i class="el-icon-plus add-styl"></i> -->
            <gj-button type="iconfont" iconfont="iconzengjia" size="20"></gj-button>
          </a>
        </el-col>
      </el-row>
    </div>
    <div class="top-input">
      <gj-input
          ref="filterInput"
          :width="'100%'"
          v-model="filterText"
          @input="searchRole"
          placeholder="输入关键字进行过滤"
      >
      </gj-input>
    </div>
    <div class="list-body" v-loading="loading">
      <template v-if="isMeaningful(roleList) && roleList.length > 0">
        <div
            v-for=" item in roleList"
            @click="clickRow(item)"
            :class="{'role-row': true, 'row-background-color': (checkRow !== null && item.id === checkRow.id)}"
            :key="item.id"
        >
          <el-row>
            <el-col :span="17" style="line-height: 30px; font-size: 12px">
              {{item.text}}
            </el-col>
            <el-col :span="7" style="text-align: right; height: 30px">
              <template v-if="item.id !== '100'">
                <span class="role-row-button">
                  <gj-button
                      font14
                      type="text"
                      style="color: #333"
                      @click.stop="openLog(item.id)"
                  >
                <i class="el-icon-document"></i>
              </gj-button>
                <gj-button
                    font14
                    type="text"
                    style="color: #333"
                    @click.stop="openEditRole(item)"
                    v-if="$permission('role:update')"
                >
                <i class="el-icon-edit"></i>
              </gj-button>
              <gj-button
                  font14
                  type="text"
                  style="color: #333"
                  @click.stop="operatorDelRole(item)"
                  v-if="$permission('role:delete')"
              >
                <i class="el-icon-delete"></i>
              </gj-button>
              </span>
              </template>
            </el-col>
          </el-row>
        </div>
      </template>
      <template v-else>
        <gj-empty style="position: relative; top: 30%; width: 150px; left: 50px"></gj-empty>
      </template>
    </div>
  </div>
</template>

<script>
  import {isMeaningful, isNotBlank} from "../../../../../utils/common";
  import {queryRoleAll, addRole, updateRole, delRole, queryRoleUser} from '../../../../../api/setting';
  import AppRoleEditModal from '../modal/role-edit-modal';
  import {isMeaningfulMixin} from "../../../../../minxins";

  export default {
    name: "app-role-list",
    mixins: [isMeaningfulMixin],
    created() {
      this.queryRoleAllList();
    },
    data() {
      return {
        loading: false,
        filterText: '',
        checkRow: null,
        modalVisible: {
          editRoleFlag: false,
          delRoleFlag: false,
        },
        modalItem: {
          editRole: null,
          delRoleRow: null,
        },
        form: {
          name: null,
        },
        roleListSource: [],
        roleList: [],
      }
    },
    methods: {
      openEditRole(item) {
        const modal = this.$gjCreate(AppRoleEditModal, {
          props: {
            item: item
          },
          on: {
            after: (data) => {
              this.queryRoleAllList();
              if (isMeaningful(data)) {
                this.clickRow(data);
              }
              modal.$gjDestroy();
            }
          }
        })
      },
      clickRow(row) {
        if (this.checkRow === null) {
          this.checkRow = row;
        } else if (this.checkRow.id !== row.id) {
          this.checkRow = row;
        }
        //发射角色id出去
        this.$emit('sendRole', row.id)
      },
      operatorDelRole(row) {
        const vm = this;
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title:'删除确认',
            content: `删除后不可恢复，是否确认删除?`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm() {
              modal.confirmLoading = true;
              const params = [];
              params.push(row.id);
              delRole(params).then(response => {
                vm.$message.success("删除成功");
                if (vm.checkRow.id === row.id) {
                  vm.checkRow = null;
                }
                vm.queryRoleAllList();
              }).complete(() => {
                modal.confirmLoading = false;
                modal.$gjDestroy();
              })
            }
          },
        });
      },
      searchRole(val) {
        if (isNotBlank(val)) {
          this.roleList = this.roleListSource.filter(v => v.text.toLowerCase().includes(val));
        } else {
          this.roleList = this.roleListSource;
        }
      },
      queryRoleAllList() {
        this.loading = true;
        queryRoleAll().then(response => {
          this.roleListSource = response.data;
          this.roleList = response.data;
          if (this.roleList && this.roleList.length > 0) {
            if (this.checkRow == null) {
              this.clickRow(this.roleList[0])
            }
          } else {
            this.checkRow = null;
            this.$emit('sendRole', null)
          }
        }).complete(() => {
          this.loading = false;
        })
      },
      openLog(id) {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: `/authority/authRoleLog/page`,
            params: {
              model: {
                roleId: id
              }
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .role-list-header {
    padding: 8px;
    background: #fff;
    font-size: 14px;
    border-bottom: 1px solid #EBEEF5;
  }

  .role-list-content {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    height: 100%;
    /* box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15); */
  }

  .role-list-header-title {
    color: #8b8c8d;
    font-weight: 700;
  }

  .top-input {
    text-align: center;
    padding: 12px;
    border-bottom: 1px solid #e8e8e8;
  }

  .add-styl {
    font-weight: bold;
    font-size: 20px;
    color: #999999;
  }

  .list-body {
    flex: 1;
    overflow: auto;
    &::-webkit-scrollbar-track{
      background: #fff;
    }
  }

  .role-row {
    padding: 2px 12px;
    /* border-bottom: 1px solid #e8e8e8; */
    font-size: 13px;
    color: #606266;
    cursor: pointer;
  }

  .role-row:hover {
    background: #EDF7FF;
  }

  .role-row:hover .role-row-button {
    display: block;
  }

  .row-background-color {
    background-color: #EDF7FF;
  }

  .role-row-button {
    display: none;
  }

  /deep/ .el-button + .el-button {
    margin-left: 5px;
  }
</style>
